module.exports = __webpack_public_path__ + "d1a38e1c75424eff76cffb13fb7480fd.jpg";